import styled from "styled-components";

export const ContainerCardsPartesPrincipais = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    > * {
        flex: 1;
        width: 100%;
        min-width: 250px;
        min-height: 120px;

        .parte-select {
            margin-top: 10px;
            align-items: center;
            display: flex;
            justify-content: center;
            margin-bottom: 10px;
            flex: 1;
        }
    }

    @media (max-width: 1200px) {
        flex-direction: column;
        
        > * {
            width: 100%;
            min-width: 100%;
        }
    }
`